import { SystemChange } from '../types/changeTracking';

class ChangeTrackingApi {
  private baseUrl = '/api/change-tracking';

  async getUserRelevantChanges(limit: number = 50, offset: number = 0): Promise<{changes: SystemChange[]}> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString()
    });

    const response = await fetch(`${this.baseUrl}/user-relevant-changes?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to get user relevant changes');
    }

    const result = await response.json();
    return result.data || result;
  }
}

export const changeTrackingApi = new ChangeTrackingApi();